import { data } from '../../svg/FolderLimited/data';
import { makeIcon } from '../makeIcon';

export const FolderLimited = makeIcon(data, 'folder_limited', 'FolderLimited');

export default FolderLimited;
